import service from './config'
class BuildService { 
    getAllList(){
        return service.get('api/Build/GetAllList')
    }
    getJsonDataById(param) {
        return service.get('api/Build/GetBuildById', param)
    }
    deleteBuildById(param) {
        return service.delete('api/Build/Delete', param)
    }
    addbuild(param) {
        return service.post('api/Build/Insert', param)
    }
    getjsondatabyid(param) {
        return service.get('api/Build/GetJsonDataById', param)
    }
    editbuildbyid(param) {
        return service.post('api/Build/Update', param)
    }
    saveLastLoadData(param) {
        return service.post('api/Build/SaveLastLoadData', param)
    }
    getByUnitName(param){
        return service.get('xfweb/Levelpic/getByUnitName', param,param)
    }
    ResetLastLoadData() {
        return service.delete('/api/Build/ResetLastLoadData')
    }
}
export default new BuildService()